import { render, staticRenderFns } from "./ItemBlock.vue?vue&type=template&id=97a3861a"
import script from "./ItemBlock.vue?vue&type=script&lang=js"
export * from "./ItemBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports